import { ArchivedFilter, BulkActionSelection, BulkSignalsInput } from "@avenueops/shared-types";
import { SelectAllState, useSelectAll, useSelectedKeys } from "context/BulkActionsContext";
import { useProcessTableState } from "context/ProcessTableContext";

interface Props {
  archived: ArchivedFilter;
  isDashboard: boolean;
}

export function useBulkSignalsInput({ archived, isDashboard }: Props): BulkSignalsInput {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const selectedIds = useSelectedKeys();
  const { selectAll } = useSelectAll();
  const [{ filters, groupBy, search, sort, timeFrame, timeFrameStartIncl, timeFrameEndExcl }] = useProcessTableState();

  return selectAll === SelectAllState.ALL
    ? {
        selection: BulkActionSelection.Enum.ALL,
        filters: {
          groupBy,
          search,
          timeFrame,
          timeFrameStartIncl: timeFrameStartIncl?.toString(),
          timeFrameEndExcl: timeFrameEndExcl?.toString(),
          filters: filters ?? [],
          sort: sort ?? [],
          timeZone,
          archived,
          isDashboard,
        },
      }
    : {
        selection: BulkActionSelection.Enum.EXPLICIT,
        signalIds: selectedIds,
      };
}
